import content from "../content/landing-page/home.json";

export type LandingFeature = { label: string; description: string };

export interface LandingPageContent {
  appName: string;
  splashTagline: string;
  splashSkipText: string;
  crystalGuidesHeading: string;
  crystalGuidesDescription: string;
  heroTagline: string;
  heroSubtitle: string;
  ctaButtonText: string;
  featureSectionHeading: string;
  features: LandingFeature[];
  privacyNote: string;
  landAcknowledgmentTitle: string;
  landAcknowledgmentBody: string;
  landAcknowledgmentArtCredit: string;
  partnerSectionHeading: string;
}

export const landingPage: LandingPageContent = content;
